import { EditorReducer } from "./Redux/Reducers/EditorReducer";
import { CompanyReducer } from "./Redux/Reducers/companyReducer";
import { ContentReducer } from "./Redux/Reducers/contentReducer";
import { FolderReducer } from "./Redux/Reducers/folderReducer";
import { formReducer } from "./Redux/Reducers/formReducer";
import PacketReducer from "./Redux/Reducers/packetReducer";
import { PartnerReducer } from "./Redux/Reducers/partnerReducer";
import { screenReducer } from "./Redux/Reducers/screenReducer";
import { userReducer } from "./Redux/Reducers/userReducer";

const { combineReducers } = require("redux");
const { playlistReducer } = require("./Redux/Reducers/playlistReducer");

export const rootReducer=combineReducers({
    Playlist:playlistReducer,
    Screen:screenReducer,
    Content:ContentReducer,
    Form:formReducer,
    User:userReducer,
    Partner:PartnerReducer,
    Company:CompanyReducer,
    Editor:EditorReducer,
    Folder:FolderReducer,
    Packet:PacketReducer
})